import BaseRepository from '@/api/repositories/BaseRepository';

class DamageAssessorApplicationRepository extends BaseRepository {
	get endpoint() {
		return 'api/damage_assessor_applications';
	}

	applyToRepairShop(damageAssessorApplicationId, damageAssessorCompany) {
		return this.put(`${damageAssessorApplicationId}/apply_to_repair_shop`, {}, { damageAssessorCompany });
	}
}

export default new DamageAssessorApplicationRepository();
